import React from "react";
import { Card } from "antd";

interface StatCardProps {
  label: string;
  value: string | number;
  description?: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, description }) => {
  return (
    <Card className="stat-box ">

      <div className="label ">{label}</div>
             <div className="value ">{value}</div>
      {description && <div className="description">{description}</div>}
    </Card>
  );
};

export default StatCard;
